const DEFAULT_LINKS = {
	whatsapp: "https://wa.me/5516992717337?text=Quero%20saber%20mais%20sobre%20o%20InstaLead%20IA",
	checkout: "/register-new-store/8",
	arquivo: "#",
	cadastro: "https://wa.me/5516992717337?text=Quero%20saber%20mais%20sobre%20o%20InstaLead%20IA%20Agencias",
};

// Utilidades visuais
const GradientLogo = () => (
	<div
		className="w-9 h-9 rounded-xl shadow-[0_0_0_2px_rgba(255,255,255,0.06)]"
		style={{
			background: "conic-gradient(from 210deg,#FEDA75,#F58529,#DD2A7B,#8134AF,#515BD4)",
		}}
		aria-hidden
	/>
);

const Button = ({ href = "#", children, primary, pill, className = "", targetBlank }) => (
	<a
		href={href}
		{...(targetBlank ? { target: "_blank", rel: "noopener" } : {})}
		className={[
			"inline-flex items-center justify-center gap-2 font-semibold no-underline",
			"px-4 py-3 rounded-xl border border-white/10 text-neutral-100",
			primary
				? "border-0 shadow-[0_10px_30px_rgba(221,42,123,0.35)] bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]"
				: "bg-transparent",
			pill ? "rounded-full" : "",
			className,
		].join(" ")}
	>
		{children}
	</a>
);

const Panel = ({ title, children, className = "" }) => (
	<div className={["bg-[#16161b] border border-white/10 rounded-2xl p-4", className].join(" ")}>
		{title ? <h4 className="m-0 mb-2 text-sm tracking-tight text-[#cfcfe6]">{title}</h4> : null}
		{children}
	</div>
);

const Chip = ({ children }) => (
	<span className="inline-block text-xs rounded-full border px-2.5 py-1 mt-1 mr-1 bg-[rgba(81,91,212,0.18)] border-[rgba(81,91,212,0.35)]">
		{children}
	</span>
);

const Bar = ({ label, value, gradient }) => (
	<div>
		<div className="flex justify-between text-xs text-[#bcc0de]">
			<span>{label}</span>
			<span>{value}</span>
		</div>
		<div className="h-3 rounded-full bg-white/10 overflow-hidden" aria-label={`Leads por ${label}`}>
			<span
				className="block h-full"
				style={{ width: `${value}%`, background: gradient, transition: "width 1.4s ease" }}
			/>
		</div>
	</div>
);

const bgRadials = {
	backgroundImage:
		"radial-gradient(1200px_800px_at_85%_-10%,rgba(253,218,120,.15),transparent_60%)," +
		"radial-gradient(1000px_800px_at_-10%_20%,rgba(221,42,123,.18),transparent_60%)," +
		"radial-gradient(900px_700px_at_50%_100%,rgba(129,52,175,.18),transparent_60%)",
};

const Container = ({ children, className = "" }) => (
	<div className={["max-w-[1140px] mx-auto px-5", className].join(" ")}>{children}</div>
);

const SectionTitle = ({ children }) => <h2 className="text-center text-[clamp(24px,3vw,36px)] m-0 mb-6">{children}</h2>;

const SectionSub = ({ children }) => (
	<p className="text-center max-w-[820px] mx-auto mb-7 text-[#a0a0b8]">{children}</p>
);

export default function InstaLeadLanding({ links, className }) {
	const L = { ...DEFAULT_LINKS, ...(links || {}) };

	return (
		<div className={className} style={{ ...bgRadials }}>
			{/* <div className="min-h-screen bg-[#0b0b0e] text-[#e9e9f1] font-[Inter,system-ui,-apple-system,Segoe_UI,Roboto,Arial,sans-serif] pt-3"> */}
			<div className="min-h-screen bg-[#0b0b0e] text-[#e9e9f1] font-poppins pt-3">
				{/* Header */}
				<header>
					<Container>
						<nav className="flex items-center justify-between py-4.5">
							<div className="flex items-center gap-3 font-extrabold tracking-tight">
								<GradientLogo />
								<span>InstaLead IA</span>
							</div>
							<div className="hidden sm:flex gap-2.5">
								<Button href="#precos" pill>
									Planos
								</Button>
								<Button href="#precos" primary pill>
									Teste grátis 7 dias
								</Button>
							</div>
						</nav>
					</Container>
				</header>

				<main>
					{/* HERO */}
					<section className="pt-16 pb-6 ">
						<Container>
							<span className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-white/10 border border-white/15 font-semibold">
								⚡ Automação segura • Conformidade Instagram & WhatsApp
							</span>
							<h1 className="text-[clamp(32px,4vw,56px)] leading-[1.05] mt-2.5 mb-3.5">
								<span className="bg-clip-text text-transparent bg-gradient-to-tr from-[#FEDA75] via-[#F58529] via-45% via-[#DD2A7B] to-[#8134AF]">
									Converta seguidores em clientes
								</span>{" "}
								com automação inteligente para Instagram
							</h1>
							<p className="text-[clamp(16px,2.2vw,20px)] text-[#a0a0b8] max-w-[760px]">
								Responda comentários e DMs automaticamente, envie botões de ação para WhatsApp, site ou
								arquivos, e use IA integrada ao WhatsApp para captar, qualificar e converter leads.
								Relatórios prontos mostram seu valor para marcas.
							</p>
							<div className="flex flex-wrap gap-3 mt-4">
								<Button href="#precos" primary pill>
									Começar teste grátis
								</Button>
								<Button href="#como-funciona" pill>
									Ver como funciona
								</Button>
							</div>

							{/* Hero media */}
							<div
								className="relative mt-9 rounded-3xl border border-white/10 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.45)]"
								style={{
									background:
										"linear-gradient(135deg,rgba(245,133,41,.25),rgba(221,42,123,.15),rgba(129,52,175,.15))",
								}}
							>
								<div className="grid grid-cols-1 md:grid-cols-[1.1fr,0.9fr] gap-4">
									{/* LEFT STACK */}
									<div className="flex flex-col gap-4">
										<Panel title="DM automatizada — Material via WhatsApp">
											<div>
												<Chip>Perguntar preço</Chip>
												<Chip>Falar no WhatsApp</Chip>
											</div>
											<p className="mt-3 text-[#c9c9de]">
												Oi! 👋 Obrigado por comentar. Quer receber o material?{" "}
												<strong>Clique no botão</strong> e continuamos no WhatsApp.
											</p>
											<Button href={L.whatsapp} primary pill className="mt-2" targetBlank>
												Abrir no WhatsApp
											</Button>
										</Panel>

										<Panel title="DM automatizada — Link de compra">
											<div>
												<Chip>Comprar agora</Chip>
												<Chip>Aplicar cupom</Chip>
											</div>
											<p className="mt-3 text-[#c9c9de]">
												Ótimo! 😍 Aqui está seu link seguro para finalizar a compra.
											</p>
											<Button href={L.checkout} primary pill className="mt-2" targetBlank>
												Ir para o checkout
											</Button>
										</Panel>

										<Panel title="DM automatizada — Entrega de arquivo">
											<div>
												<Chip>Receber e‑book</Chip>
												<Chip>Ver prévia</Chip>
											</div>
											<p className="mt-3 text-[#c9c9de]">
												Perfeito! 📩 Clique abaixo para baixar seu material agora mesmo.
											</p>
											<Button href={L.arquivo} primary pill className="mt-2" targetBlank>
												Baixar arquivo
											</Button>
										</Panel>
									</div>

									{/* RIGHT: Relatório + Dashboard */}
									<Panel title="Relatório de Leads">
										<p className="text-[#cfcfe6]">Resumo semanal por origem do lead</p>
										<div className="grid gap-2 mt-2">
											<Bar
												label="Comentários"
												value={86}
												gradient="linear-gradient(90deg,#F58529,#DD2A7B)"
											/>
											<Bar
												label="DMs"
												value={64}
												gradient="linear-gradient(90deg,#8134AF,#515BD4)"
											/>
											<Bar
												label="Stories"
												value={42}
												gradient="linear-gradient(90deg,#FEDA75,#F58529)"
											/>
										</div>
										<div className="flex flex-wrap gap-2 mt-2 items-center">
											<span
												className="w-2.5 h-2.5 rounded-full"
												style={{ background: "#F58529" }}
											></span>
											<small>Comentários</small>
											<span
												className="w-2.5 h-2.5 rounded-full ml-3"
												style={{ background: "#8134AF" }}
											></span>
											<small>DMs</small>
											<span
												className="w-2.5 h-2.5 rounded-full ml-3"
												style={{ background: "#FEDA75" }}
											></span>
											<small>Stories</small>
										</div>

										{/* KPIs */}
										<div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
											<div className="bg-[#141419] border border-white/10 rounded-xl p-3">
												<h5 className="m-0 mb-1 text-xs text-[#bfc0d9]">Taxa de resposta</h5>
												<div className="font-extrabold text-lg">92%</div>
												<small className="text-[#8ddcaa]">▲ +14% vs. semana anterior</small>
											</div>
											<div className="bg-[#141419] border border-white/10 rounded-xl p-3">
												<h5 className="m-0 mb-1 text-xs text-[#bfc0d9]">Conversão em lead</h5>
												<div className="font-extrabold text-lg">27%</div>
												<small className="text-[#8ddcaa]">▲ +5 p.p.</small>
											</div>
											<div className="bg-[#141419] border border-white/10 rounded-xl p-3">
												<h5 className="m-0 mb-1 text-xs text-[#bfc0d9]">
													Tempo médio de resposta
												</h5>
												<div className="font-extrabold text-lg">1m 42s</div>
												<small className="text-[#f3bf7a]">≈ estável</small>
											</div>
										</div>

										{/* Donut */}
										<div className="mt-4 bg-[#1c1c22] border border-white/10 rounded-xl p-4">
											<h4 className="mt-0">Distribuição de Conversões</h4>
											<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
												<div className="mx-auto">
													<svg
														className="w-40 h-40 block mx-auto"
														viewBox="0 0 42 42"
														role="img"
														aria-label="Distribuição de conversões"
													>
														<circle cx="21" cy="21" r="15.9155" fill="#101015" />
														<defs>
															<linearGradient id="g1" x1="0" x2="1">
																<stop offset="0%" stopColor="#F58529" />
																<stop offset="100%" stopColor="#DD2A7B" />
															</linearGradient>
															<linearGradient id="g2" x1="0" x2="1">
																<stop offset="0%" stopColor="#8134AF" />
																<stop offset="100%" stopColor="#515BD4" />
															</linearGradient>
															<linearGradient id="g3" x1="0" x2="1">
																<stop offset="0%" stopColor="#FEDA75" />
																<stop offset="100%" stopColor="#F58529" />
															</linearGradient>
														</defs>
														<circle
															cx="21"
															cy="21"
															r="15.9155"
															fill="transparent"
															stroke="url(#g1)"
															strokeWidth="6"
															strokeDasharray="48 52"
															strokeDashoffset="25"
														/>
														<circle
															cx="21"
															cy="21"
															r="15.9155"
															fill="transparent"
															stroke="url(#g2)"
															strokeWidth="6"
															strokeDasharray="32 68"
															strokeDashoffset="-23"
														/>
														<circle
															cx="21"
															cy="21"
															r="15.9155"
															fill="transparent"
															stroke="url(#g3)"
															strokeWidth="6"
															strokeDasharray="20 80"
															strokeDashoffset="-55"
														/>
													</svg>
													<div className="relative w-40 mx-auto -mt-28 text-center">
														<strong className="text-xl">ROI</strong>
														<div className="text-xs text-[#bdbdd3]">por canal</div>
													</div>
												</div>
												<div className="self-center">
													<div className="grid gap-2 text-sm text-[#d9d9ef]">
														<div className="flex justify-between gap-3">
															<span className="flex items-center">
																<span
																	className="w-2.5 h-2.5 rounded-full mr-2"
																	style={{ background: "#F58529" }}
																/>
																Comentários
															</span>
															<strong>48%</strong>
														</div>
														<div className="flex justify-between gap-3">
															<span className="flex items-center">
																<span
																	className="w-2.5 h-2.5 rounded-full mr-2"
																	style={{ background: "#8134AF" }}
																/>
																DMs
															</span>
															<strong>32%</strong>
														</div>
														<div className="flex justify-between gap-3">
															<span className="flex items-center">
																<span
																	className="w-2.5 h-2.5 rounded-full mr-2"
																	style={{ background: "#FEDA75" }}
																/>
																Stories
															</span>
															<strong>20%</strong>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Panel>
								</div>
							</div>
						</Container>
					</section>

					{/* BENEFÍCIOS */}
					<section id="como-funciona" className="py-16">
						<Container>
							<SectionTitle>A automação que trabalha por você</SectionTitle>
							<SectionSub>
								Conecte Instagram + WhatsApp, defina gatilhos e deixe a IA conduzir a conversa até a
								conversão. Tudo com sua voz e personalidade.
							</SectionSub>
							<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
								<div className="bg-[#16161b] border border-white/10 rounded-2xl p-5">
									<div className="w-9 h-9 rounded-xl flex items-center justify-center font-extrabold bg-gradient-to-tr from-[#F58529] to-[#DD2A7B]">
										💬
									</div>
									<h3 className="mt-1.5 mb-2 text-lg">Comentários & DMs automáticos</h3>
									<p className="text-[#a0a0b8]">
										Respostas instantâneas com botões de ação para link, arquivo ou WhatsApp.
									</p>
								</div>
								<div className="bg-[#16161b] border border-white/10 rounded-2xl p-5">
									<div className="w-9 h-9 rounded-xl flex items-center justify-center font-extrabold bg-gradient-to-tr from-[#F58529] to-[#DD2A7B]">
										🤖
									</div>
									<h3 className="mt-1.5 mb-2 text-lg">Fluxos com IA</h3>
									<p>Qualifique, informe e converta sem esforço. Personalize mensagens e regras.</p>
								</div>
								<div className="bg-[#16161b] border border-white/10 rounded-2xl p-5">
									<div className="w-9 h-9 rounded-xl flex items-center justify-center font-extrabold bg-gradient-to-tr from-[#F58529] to-[#DD2A7B]">
										🔗
									</div>
									<h3 className="mt-1.5 mb-2 text-lg">Integrações</h3>
									<p>WhatsApp, páginas, catálogos e materiais em nuvem — sem fricção.</p>
								</div>
								<div className="bg-[#16161b] border border-white/10 rounded-2xl p-5">
									<div className="w-9 h-9 rounded-xl flex items-center justify-center font-extrabold bg-gradient-to-tr from-[#F58529] to-[#DD2A7B]">
										📊
									</div>
									<h3 className="mt-1.5 mb-2 text-lg">Relatórios de Leads</h3>
									<p>Prove valor para marcas com dados de captação, origem e conversão.</p>
								</div>
							</div>
						</Container>
					</section>

					{/* PREÇOS */}
					<section id="precos" className="py-16">
						<Container>
							<SectionTitle>Planos simples, crescimento real</SectionTitle>
							<SectionSub>
								Comece grátis e evolua quando precisar de mais alcance e automações.
							</SectionSub>

							<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 items-stretch">
								{/* Grátis */}
								<div className="relative bg-[#16161b]/95 border border-white/10 rounded-2xl p-5 flex flex-col">
									<div className="absolute top-4 right-4 bg-gradient-to-tr from-[#FEDA75] to-[#F58529] px-2.5 py-1 rounded-full text-[#1a1a1f] font-extrabold text-xs border border-black/10">
										GRÁTIS 7 DIAS
									</div>
									<h3 className="text-lg">Teste Grátis</h3>
									<div className="text-3xl font-extrabold my-2">R$ 0</div>
									<ul className="list-none p-0 m-0 text-[#c9c9de] space-y-2">
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											7 dias com funcionalidades completas
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Comentários e DMs automáticos
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											1 fluxo de IA no WhatsApp
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Relatório de leads (CSV)
										</li>
									</ul>
									<Button href={L.checkout} primary pill className="mt-4" targetBlank>
										Começar agora
									</Button>
								</div>

								{/* Pro Criador */}
								<div className="relative bg-[#16161b] border border-white/10 rounded-2xl p-5 shadow-[0_20px_60px_rgba(221,42,123,0.25)] flex flex-col">
									<div className="absolute top-4 right-4 bg-gradient-to-tr from-[#FEDA75] to-[#F58529] px-2.5 py-1 rounded-full text-[#1a1a1f] font-extrabold text-xs border border-black/10">
										MAIS POPULAR
									</div>
									<h3 className="text-lg">Pro Criador</h3>
									<div className="text-3xl font-extrabold my-2">R$ 149/mês</div>
									<ul className="list-none p-0 m-0 text-[#c9c9de] space-y-2">
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Tudo do Teste + ilimitado em respostas
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Até 5 fluxos de IA e gatilhos
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Segmentação por palavra-chave/hashtag
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Painel avançado e exportações
										</li>
									</ul>
									<Button href={L.checkout} primary pill className="mt-4" targetBlank>
										Experimentar Pro
									</Button>
								</div>

								{/* Agência */}
								<div className="relative bg-[#16161b]/95 border border-white/10 rounded-2xl p-5 flex flex-col">
									<h3 className="text-lg">Agência</h3>
									<div className="text-3xl font-extrabold my-2">R$ 449/mês</div>
									<ul className="list-none p-0 m-0 text-[#c9c9de] space-y-2">
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											10 perfis + acesso de equipe
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											Fluxos ilimitados e templates
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											SLA e gerente dedicado
										</li>
										<li className="flex gap-2">
											<span className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#F58529] to-[#DD2A7B] inline-block mt-0.5" />
											API e webhooks
										</li>
									</ul>
									<Button href={L.cadastro} primary pill className="mt-4" targetBlank>
										Falar com vendas
									</Button>
								</div>
							</div>
						</Container>
					</section>

					{/* DEPOIMENTOS */}
					<section className="py-16">
						<Container>
							<SectionTitle>Criadores que já estão convertendo</SectionTitle>
							<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-4">
								{[
									{
										text: "“Minha taxa de resposta foi de 34% para 92% em 2 semanas. Fechei 2 contratos porque finalmente tenho dados de leads para mostrar.”",
										author: "@carla.fit • 58k seguidores",
									},
									{
										text: "“Enquanto gravo, as DMs e comentários são respondidos. A IA no WhatsApp faz a triagem e só me entrega os leads quentes.”",
										author: "@edu.tech • 41k seguidores",
									},
									{
										text: "“O botão direto para o WhatsApp reduziu muito a fricção. O fluxo virou padrão nas minhas campanhas com marcas.”",
										author: "@vivis.bz • 23k seguidores",
									},
								].map((q, i) => (
									<div key={i} className="bg-[#16161b] border border-white/10 rounded-2xl p-4">
										<p>{q.text}</p>
										<div className="flex items-center gap-2 mt-2 text-[#cfcfe6]">
											<div className="w-9 h-9 rounded-full bg-gradient-to-tr from-[#8134AF] to-[#515BD4]" />
											<div>{q.author}</div>
										</div>
									</div>
								))}
							</div>
						</Container>
					</section>

					{/* FAQ */}
					<section className="py-16">
						<Container>
							<SectionTitle>Perguntas Frequentes</SectionTitle>
							<div className="space-y-3">
								<details className="bg-[#16161b] border border-white/10 rounded-xl p-3">
									<summary className="cursor-pointer font-bold">
										É seguro usar automação no Instagram?
									</summary>
									<p className="mt-2">
										Sim. Seguimos boas práticas e limites recomendados, evitando ações massivas que
										violem políticas. Você controla os gatilhos e conteúdos.
									</p>
								</details>
								<details className="bg-[#16161b] border border-white/10 rounded-xl p-3">
									<summary className="cursor-pointer font-bold">
										Como funciona a integração com WhatsApp?
									</summary>
									<p className="mt-2">
										Ao acionar um botão na DM/comentário, abrimos a conversa no WhatsApp e a IA
										assume o fluxo definido: coletar dados, responder dúvidas e qualificar.
									</p>
								</details>
								<details className="bg-[#16161b] border border-white/10 rounded-xl p-3">
									<summary className="cursor-pointer font-bold">Posso exportar os leads?</summary>
									<p className="mt-2">
										Sim, com um clique você exporta CSV com nome, contato, origem e etapa da
										qualificação.
									</p>
								</details>
								<details className="bg-[#16161b] border border-white/10 rounded-xl p-3">
									<summary className="cursor-pointer font-bold">
										Posso personalizar as mensagens?
									</summary>
									<p className="mt-2">
										Totalmente. Defina tom, palavras-chave, horários e exceções para manter sua voz
										autêntica.
									</p>
								</details>
							</div>
						</Container>
					</section>
				</main>

				{/* Footer */}
				<footer className="border-t border-white/10 py-6 text-[#bdbdd3]">
					<Container>
						<div className="flex flex-wrap gap-3 items-center justify-between">
							<div>{`© ${new Date().getFullYear()} • InstaLead IA — Automação para Instagram`}</div>
							<div className="opacity-80">Política de Privacidade • Termos • Contato</div>
						</div>
					</Container>
				</footer>
			</div>
		</div>
	);
}
